@if (noData) {
  <h4 class="text-disabled">No New Notifications</h4>
}
@if (!noData) {
  <div>
    <table mat-table [dataSource]="rows" class="mat-elevation-z8 paymentNotificationsTable">
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>{{ 'Title'  }}</th>
        <td mat-cell *matCellDef="let items">
          {{ items.title }}
        </td>
      </ng-container>
      <ng-container matColumnDef="loanId">
        <th mat-header-cell *matHeaderCellDef>{{ 'Loan Id'  }}</th>
        <td mat-cell *matCellDef="let items">
          {{ items.loanId }}
        </td>
      </ng-container>
      <ng-container matColumnDef="instituteName">
        <th mat-header-cell *matHeaderCellDef>{{ 'Institute Name'  }}</th>
        <td mat-cell *matCellDef="let items">
          {{ items.instituteName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>{{ 'Notification Type'  }}</th>
        <td mat-cell *matCellDef="let items">
          {{ items.type }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <!-- loader -->
      @if (loader) {
        <div class="mt-spinner-container">
          <loader></loader>
        </div>
      }
    </table>
  </div>
}